<template>
	<div class="agb">
		<b-container class="mt-top text-left prl-outside">
		<b-row class="mb-3 top-text">{{$t('title')}}</b-row>

		<b-row class="prl-inside">
			<h4>{{$t('privacy')}}</h4>
			<p>{{$t('privacy1')}}</p>
			<p>{{$t('privacy2')}}</p>

			<h4>{{$t('contact')}}</h4>
			<p>{{$t('contact1')}}</p>

			<h4>{{$t('cookies')}}</h4>
			<p>{{$t('cookies1')}}</p>
			<p>{{$t('cookies2')}}</p>
			<p>{{$t('cookies3')}}</p>
			<p>{{$t('cookies4')}}</p>

			<h4>{{$t('rights')}}</h4>
			<p v-html="$t('rights1')"></p>
			<p>{{$t('rights2')}}:</p>
			<p>GERA – Montagen für Tischlereiprodukte GmbH<br>
			Mettersdorf 109 | A-8092 Mettersdorf<br>Tel: +43 (0) 3477/3445 | Fax: +43 (0) 3477/3445 4 | E-mail: <a href="mailto:office@gera.at">office@gera.at</a>
			</p>
		</b-row>
		</b-container>
		<div class="big-text text-left">{{$t('title')}}</div>
	</div>
</template>

<script>
export default {
	name: 'Agb',
	data () {
		return {
		}
	}
}
</script>
<style scoped>
	p {
		width: 100%;
		font-size: 0.9rem;
	}
</style>
<i18n>
	{
		"de": {
			"title": "Datenschutz",
			"privacy": "Datenschutzerklärung",
			"privacy1": "Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen. Wir verarbeiten Ihre Daten daher ausschließlich auf Grundlage der gesetzlichen Bestimmungen (DSGVO, TKG 2003). In diesen Datenschutzinformationen informieren wir Sie über die wichtigsten Aspekte der Datenverarbeitung im Rahmen unserer Website.",
			"privacy2": "Beim Besuch unserer Webseite wird Ihre IP-Adresse, Beginn und Ende der Sitzung für die Dauer dieser Sitzung erfasst. Dies ist technisch bedingt und stellt damit ein berechtigtes Interesse iSv Art 6 Abs 1 lit f DSGVO dar. Soweit im Folgenden nichts anderes geregelt wird, werden diese Daten von uns nicht weiterverarbeitet.",
			"contact": "Kontakt mit uns",
			"contact1": "Wenn Sie per Formular auf der Website oder per E-Mail Kontakt mit uns aufnehmen, werden Ihre angegebenen Daten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen sechs Monate bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.",
			"cookies": "Cookies",
			"cookies1": "Unsere Website verwendet so genannte Cookies. Dabei handelt es sich um kleineTextdateien, die mit Hilfe des Browsers auf Ihrem Endgerät abgelegt werden. Sie richten keinen Schaden an.",
			"cookies2": "Wir nutzen Cookies dazu, unser Angebot nutzerfreundlich zu gestalten. Einige Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen. Sie ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.",
			"cookies3": "Wenn Sie dies nicht wünschen, so können Sie Ihren Browser so einrichten, dass er Sie über das Setzen von Cookies informiert und Sie dies nur im Einzelfall erlauben.",
			"cookies4": "Bei der Deaktivierung von Cookies kann die Funktionalität unserer Website eingeschränkt sein.",
			"rights": "Ihre Rechte",
			"rights1": "Ihnen stehen bezüglich Ihrer bei uns gespeicherten Daten grundsätzlich die Rechte auf Auskunft, Berichtigung, Löschung, Einschränkung, Datenübertragbarkeit, Widerruf und Widerspruch zu. Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstößt oder Ihre datenschutzrechtlichen Ansprüche sonst in einer Weise verletzt worden sind, können Sie sich bei der uns <a href=\"mailto:office@gera.at\">office@gera.at</a> oder der Datenschutzbehörde beschweren.",
			"rights2": "Sie erreichen uns unter folgenden Kontaktdaten"
		},
		"en": {
			"title": "Data protection",
			"privacy": "Privacy Policy",
			"privacy1": "Protecting your personal data is a special concern to us. Therefore, we process your data solely on the basis of statutory provisions (GDPR, TKG [Telecommunications Act] 2003). In this privacy policy we inform you about the most important aspects of data processing on our website.",
			"privacy2": "When you visit our website, your IP address and the beginning and the ending of the session are recorded for the duration of that session. This is due to technical reasons and thus constitutes a legitimate interest as defined by Article 6 Paragraph 1 Letter f GDPR. Provided that nothing to the contrary is regulated in the following, we will not further process this data.",
			"contact": "Contact with us",
			"contact1": "If you make contact with us by the form on the website or by email, the data that you indicate is stored by us for 6 months for the purpose of processing your inquiry and in the event that you have follow-up questions. We do not disclose this data without your consent.",
			"cookies": "Cookies",
			"cookies1": "Our website uses what are called cookies. Cookies are small text files that are stored on your device with the help of your browser. They cause no harm.",
			"cookies2": "We use cookies to design our site in a way that is user-friendly. Some cookies remain stored on your device until you delete them. They enable us to recognise your browser at your next visit.",
			"cookies3": "If you do not desire this, you can set your browser in such a way that it informs you about cookies being placed, and you only allow this in individual cases.",
			"cookies4": "If you deactivate cookies, it may restrict the functionality of our website.",
			"rights": "Your rights",
			"rights1": "In regards to your data that we store, you have the rights to information, rectification, erasure, restriction, data portability, withdrawal and objection. If you believe that the processing of your data violates data protection law or your claims under data protection law have been violated in some other way, you can complain to us at <a href=\"mailto:office@gera.at\">office@gera.at</a> as well as to the data protection authorities.",
			"rights2": "You can reach us using the following contact information"
		}
	}
</i18n>
